import api from "./api";

export async function getPushPublicKey() {
  const r = await api.get("/push/public-key");
  return r.data.data as { publicKey: string | null; habilitado: boolean };
}

export async function subscribePush(sub: PushSubscription) {
  const json: any = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: sub.endpoint, keys: json.keys, userAgent: navigator.userAgent });
}

export async function unsubscribePush(endpoint?: string) {
  await api.post("/push/unsubscribe", { endpoint });
}

export async function testPush() {
  await api.post("/push/test");
}

export async function disparoLocalDeTeste() {
  // Dispara uma Notification local imediatamente (não passa pelo servidor)
  if (!("Notification" in window)) throw new Error("Browser sem suporte");
  if (Notification.permission !== "granted") throw new Error("Permissão não concedida");
  try {
    const reg = await navigator.serviceWorker.getRegistration("/");
    if (reg) {
      await reg.showNotification("RECDC OS", {
        body: "Teste local — esta notificação veio do service worker.",
        icon: "/vite.svg",
        tag: "test-local",
      } as NotificationOptions);
    } else {
      new Notification("RECDC OS", { body: "Teste local sem service worker.", icon: "/vite.svg" });
    }
  } catch (e: any) {
    throw new Error(e?.message || "Falha ao mostrar notificação local");
  }
}
